<template>
    <div class="pro_box">
        <div class="top_img">
            <img src="../../../assets/icons/官网首页_slices/details_about.png" alt="">
            <div class="top_font">
                <div class="font_title">关于婧贤</div>
                <div class="font_deputy">About</div>
            </div>
        </div>
        <div class="tbs_box">
            <div 
                class="tab_item" 
                :class="[active==item.id?'cactive':'',index==0?'top_border':'']"
                @click="tabswitch(item)"
                v-for="(item,index) of tab" :key="index">
                {{ item.title }}
            </div>
        </div>
        <div class="content_box">
            <div v-if="active==1" class="company">
                <div v-html="company"></div>
            </div>
            <div v-if="active==2" class="contact">
                <!-- <div class="font_amap">联系我们</div> -->
                <div class="contact_amap">
                    <div class="tab_amap">
                        <div
                            :class="[seladd==item.id?'addactive':'']" 
                            class="button_box" 
                            @click="addressswitch(item)"
                            v-for="(item,index) of appoption" 
                            :key="index">
                            {{ item.title }}
                        </div>
                    </div>
                    <el-amap 
                        class="amap-box"  
                        :plugin='plugin' 
                        :zoom="zoom" 
                        :center="center" 
                        :events="events" 
                        :mapStyle="mapStyle">
                        <el-amap-marker 
                        v-for="(marker, i) in markers" 
                        :key="i" 
                        :position="marker"></el-amap-marker>
                    </el-amap>
                    <div class="address">
                        <div>
                            <div class="address_title">公司地址：</div>
                            <div class="address_con">{{ info.address }}</div>
                            <div class="address_title">公司邮箱：</div>
                            <div class="address_con">{{ info.email }}</div>
                            <div class="address_title">联系电话：</div>
                            <div class="address_phone" v-for="(item,index) of info.handle" :key="index">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bottomnav :display="true"></bottomnav>
    </div>
</template>
<script>
import bottomnav from './bottomnav.vue';
export default{
    components:{bottomnav},
    data(){
        return{
            active:null,
            appoption:[
                {id:0,title:'地址一'},
                {id:1,title:'地址二'},
            ],
            seladd:null,
            tab:[
                {id:1,title:'公司概况'},
                {id:2,title:'联系我们'},
            ],
            companyInfoList:{},
            info:{},

            center: [91.172488,29.652249], //地图中心点坐
            zoom: 14, //初始化地图显示层级
            mapStyle: "amap://styles/8b6be8ec497009e17a708205348b899a", //设置地图样式
            markers: [
                [91.172488,29.652244]
            ],
            searchOption: {city: "成都",citylimit: true},
            address: "",
            lng: 117.120098,
            lat: 36.6512,
            plugin: [{pName: "Scale"},],
            events: {
                init: (map) => {
                    var geocoder = new AMap.Geocoder({
                        radius: 1000,
                        extensions: "all",
                        city: "全国"
                    });
                    geocoder.getLocation(this.address, (status, result) => {
                        if (status === "complete" && result.geocodes.length) {
                            
                            let lnglat = result.geocodes[0].location
                            this.lng = lnglat.lng;
                            this.lat = lnglat.lat;
                            this.center = [this.lng, this.lat];
                        }
                    });
                },
                moveend: () => {

                },
                zoomchange: () => {

                },
                click: (e) => {
                  
                    
                    // let { lng, lat } = e.lnglat;
                    // this.center = [lng, lat];
                    // this.markers = [[lng, lat]];
                    // this.lng = lng;
                    // this.lat = lat;
                    //  var geocoder = new AMap.Geocoder({
                    //     radius: 1000,
                    //     extensions: "all",
                    //     city: "全国"
                    // });
                    // geocoder.getAddress([this.lng  ,this.lat  ], (status, result) => {
                    //     if (status === 'complete' && result.info === 'OK') {
                    //         this.searchOption.city=result.regeocode.addressComponent.city
                    //     }
                    // });
                // 这里通过高德 SDK 完成。
                },
            },
            company:''
        }
    },
    created(){
        this.seladd=this.appoption[0].id;
        if(this.$route.query.type){
            this.active=Number(this.$route.query.type)
        }else{
            this.active=this.tab[0].id;
        }
        this.axiosdata()
    },
    methods:{
        axiosdata(){
            this.$webhttp.get('v1/web/company').then((res)=>{
                if(res.code==200){
                    this.company=res.data.overview
                    res.data.companyInfoList.forEach((item,index) => {
                        item['handle']=[]
                        if(item.phone.indexOf(',')!=-1){
                            item.phone.split(',').forEach((items)=>{
                                item['handle'].push(items)
                            })
                        }else{
                           item['handle'].push(item.phone)
                        }
                        if(item.email==''&& item.phone=='' && item.address==''){
                            this.appoption.splice(index,1)
                        }
                    });
                    
                    this.companyInfoList=res.data.companyInfoList        
                    this.info=this.companyInfoList[0]
                 
                    this.updatemap(this.info.longitude,this.info.latitude)
                    
                }else{
                    this.$message.error(res.message)
                }
            })
            
        },
        updatemap(lng,lat){
            this.markers =[[lng,lat]];
            this.center=[lng,lat]
        },
        addressswitch(item){
            this.info=this.companyInfoList[item.id]
            this.updatemap(this.info.longitude,this.info.latitude)
            this.seladd=item.id;
        },
        tabswitch(item){
            this.active=item.id
        }
    },
}
</script>
<style lang="less" scoped>
    .pro_box{
        width: 100%;
        box-sizing: border-box;
        min-height: 450px;
        .content_box{
            height: 100%;
            width:100%;
            box-sizing: border-box;
            padding: 0% 3.5% 0% 3.5%;
            .company{
                box-sizing: border-box;
                margin-bottom: 40px;
                font-size: 38px;
            }
            .contact{
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                .contact_amap{
                    width: 100%;
                    height: 100%;
                    position: relative;
                    .tab_amap{
                        position: absolute;
                        top: 20px;
                        left: 20px;
                        z-index: 2;
                        display: flex;
                        .addactive{
                            background: #027DFC !important;
                            font-weight: 400;
                            font-size: 28px;
                            color: #FFFFFF;
                        }
                        .button_box:hover{
                            background: #027DFC;
                            font-weight: 400;
                            font-size: 28px;
                            color: #FFFFFF;
                        }
                        .button_box{
                            width: 145px;
                            height: 58px;
                            background: #FFFFFF;
                            border: 1px solid #ECECEC;
                            text-align: center;
                            font-size: 28px;
                            line-height: 58px;
                            cursor: pointer;
                        }
                    }
                    .address{
                        margin-bottom: 190px;
                        .address_title{
                            font-weight: 400;
                            font-size: 38px;
                            color: #606060;
                        }
                        .address_phone{
                            font-weight: 400;
                            color: #101010;
                            font-size: 40px;
                        }
                        .address_con{
                            font-weight: 400;
                            margin-bottom: 55px;
                            color: #101010;
                            font-size: 40px;
                        }
                    }
                    .amap-box{
                        width: 100%;
                        height: 520px;
                        margin-bottom: 45px;
                    }
                }
                .font_amap{
                    font-weight: normal;
                    font-size: 20px;
                    color: #101010;
                    margin-bottom: 22px;
                }
            }
        }
        .tbs_box{
            height: 100%;
            box-sizing: border-box;
            padding-top: 45px;
            padding-bottom: 35px;
            width: 100%;
            padding-left: 3.5%;
            display: flex;
            .tab_item:hover{
                background: #027DFC;
                font-weight: 400;
                font-size: 30px;
                color: #FFFFFF;
                line-height: 70px;
            }
            .cactive{
                background: #027DFC !important;
                color: #FFFFFF !important;
            }
            .tab_item{
                border: 1px solid #ECECEC;
                background: #FFFFFF;
                height: 75px;
                width: 31%;
                text-align: center;
                line-height: 70px;
                box-sizing: border-box;
                cursor: pointer;
                font-weight: 400;
                font-size: 30px;
                color: #606060;;
            }
        } 
        .top_img{
                width: 100%;
                height: 250px;
                position: relative;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .top_font{
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    color: #FFFFFF;
                    text-align: center;
                    transform: translateX(-50%) translateY(-50%);
                    .font_title{
                        font-weight: bold;
                        font-size: 38px;
                        color: #FFFFFF;
                        line-height: 60px;
                        text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                    }
                    .font_deputy{
                        font-weight: 400;
                        font-size: 36px;
                        color: #FFFFFF;
                        text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                    }
                }
        }
    }

</style>